export default "__VITE_ASSET__12433443__"